export default __webpack_public_path__ + "static/media/Joltify_website-terms-and-conditions-of-use-services.34ee9daa.pdf";